/**
 * Application configuration
 *
 * Centralized config for API endpoints and environment variables.
 *
 * IMPORTANT: Vite replaces `import.meta.env.VITE_*` references with literal values at BUILD TIME.
 * - Environment variables MUST be available during `pnpm build` (not at runtime)
 * - GitHub Actions workflow exports these via env: block in the build step
 * - For local dev, use .env or .env.local files
 *
 * DO NOT wrap import.meta.env values in functions - Vite can only replace direct references!
 *
 * Environments:
 * - dev: Development environment
 * - qual: QA/Testing environment
 * - prod: Production environment
 */
export const config = {
    // API Endpoints - All required, validated at build time
    api: {
        identity: import.meta.env.VITE_IDENTITY_API_URL,
        people: import.meta.env.VITE_PEOPLE_API_URL,
        time: import.meta.env.VITE_TIME_API_URL,
        leave: import.meta.env.VITE_LEAVE_API_URL,
        payroll: import.meta.env.VITE_PAYROLL_API_URL,
        schedule: import.meta.env.VITE_SCHEDULE_API_URL,
        compliance: import.meta.env.VITE_COMPLIANCE_API_URL,
        notifications: import.meta.env.VITE_NOTIFICATIONS_API_URL,
    },
    // Cognito Authentication
    auth: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID,
        clientId: import.meta.env.VITE_CLIENT_ID,
        region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
    },
    // Default tenant (optional, has sensible default)
    defaultTenantId: import.meta.env.VITE_DEFAULT_TENANT_ID || 'tenant-001',
};
